import React, { useState, useEffect } from "react";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import Parser from "html-react-parser";
import Meta from "@components/Meta/Meta";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";
import CardTypeFolder from "@components/CardTypeFolder/CardTypeFolder";
import useMediaQuery from "app/hooks/useMediaQuery";

import "./InversionesInfo.css";
const ROOT = process.env.REACT_APP_CMS_STATIC;

const InversionesInfo = ({ inversion, borderTopColor, ...props }) => {
  const [meta, setMeta] = useState({});
  const [itemsBreadcrumb, setItemsBreadcrumb] = useState([]);
  const [investment] = useState(inversion);
  const [detailTitleStyle, setDetailTitleStyle] = useState({
    minWidth: "225px",
    maxWidth: "75%",
    width: "fit-content",
  });

  const isDesktop = useMediaQuery("(min-width: 992px)");
  const isIpadPortrait = useMediaQuery("(max-width: 992px)");
  const isIphoneLandscape = useMediaQuery("(max-width: 576px)");

  const getWidthTitle = () => {
    if (isIphoneLandscape) {
      setDetailTitleStyle({
        minWidth: "178",
        maxWidth: "100%",
        width: "fit-content",
      });
    } else if (isIpadPortrait || isIphoneLandscape) {
      setDetailTitleStyle({
        minWidth: "225px",
        maxWidth: "75%",
        width: "fit-content",
      });
    }
  };

  useEffect(() => {
    getWidthTitle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDesktop, isIpadPortrait, isIphoneLandscape]);

  useEffect(() => {
    if (!isEmpty(inversion)) {
      setMeta((m) => {
        return {
          ...m,
          title: inversion.title,
          description: inversion.description,
          url: `/${inversion.idInversion}`,
        };
      });

      if (inversion.prevRoute) {
        setItemsBreadcrumb([
          {
            url: "#" /*inversion.prevRoute[0].url*/,
            text: inversion.prevRoute[0].text,
          },
        ]);
      } else {
        setItemsBreadcrumb([
          { url: `${inversion.idInversion}`, text: inversion.title },
        ]);
      }
    }
  }, [inversion]);

  return (
    <>
      <Meta
        title={meta?.title + " | Inversiones | CS Ahorro y Crédito Costa Rica"}
        description={meta?.description}
        canonicalUrl={meta?.url}
      />
      <Breadcrumbs items={itemsBreadcrumb} active={investment.title} />
      <div className="investment-container">
        <div className="w-100 d-flex flex-column align-items-start text-left">
          <h1 className="investment-title">{investment.title}</h1>
          <span className="investment-description">
            {Parser(investment.description)}
          </span>
        </div>
        <div className="w-100">
          {investment.details &&
            investment.details.map((detail, index) => (
              <CardTypeFolder
                key={index}
                titleStyle={detailTitleStyle}
                title={detail.title}
                description={detail.description.html}
                borderTopColor={borderTopColor}
              />
            ))}
          {investment.files && investment.files.length > 0 && (
            <CardTypeFolder
              titleStyle={detailTitleStyle}
              title="Documentos"
              description=""
              files={
                investment.files &&
                investment.files.map((file) => {
                  return {
                    fileName: file.tituloEnlace,
                    fileURL: ROOT + file.archivo.urls[0],
                  };
                })
              }
              borderTopColor={borderTopColor}
            />
          )}
        </div>
      </div>
    </>
  );
};

InversionesInfo.propTypes = {
  inversion: PropTypes.object.isRequired,
  borderTopColor: PropTypes.string,
};

export default InversionesInfo;
